<template>
  <div class="board mh-0" id="board" :key="'board-view-' + viewId">
    <board-shimmer v-if="isFetchingGroups" />
    <div class="columns-wrapper" v-else>
      <div
        class="board-column d-flex flex-column"
        v-for="(group, index) in groups"
        :key="index"
        :style="{ backgroundColor: groupInfo[index].color }"
      >
        <div class="text-medium-1 bold group-name d-flex align-items-center">
          <i class="mr-2" :class="groupInfo[index].icon" v-if="groupInfo[index].icon" />
          {{ groupInfo[index].formattedGroupName }}
          <span v-if="group.length">&nbsp;({{ group.length }})</span>
        </div>
        <div
          class="cards-container initiatives-view-scroll-container"
          :data-group-index="index"
          :ref="'group-' + groupInfo[index].name"
          :data-id="group.id"
        >
          <template v-for="initiative in group">
            <initiative-card
              :data-id="initiative.id"
              :key="initiative.id + ' ' + initiative.keyResultId"
              :initiative="initiative"
              :initiatives="group"
              :krs="krs"
              :group-by="groupBy"
              :group-name="groupInfo[index].name"
              :hide-status="groupBy === statusKey"
              @save="$emit('save', { after: $event, before: initiative, groupIndex: index })"
              @remove="$emit('remove', { initiative, groupIndex: index })"
              @update="$emit('update', { initiative: $event, groupIndex: index })"
            />
          </template>
        </div>
        <div class="mt-2">
          <b-button
            variant="link"
            class="text-secondary text-medium add-initiative"
            @click="$emit('add', index)"
          >
            + Initiative
          </b-button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import BoardShimmer from '@/components/board/BoardShimmer'
import InitiativeCard from '@/components/board/InitiativeCard'
import { INITIATIVE_FIELDS } from '@/constants/initiative'
import { BButton } from 'bootstrap-vue'
import * as R from 'ramda'

/**
 * This components shows initiatives in a board view
 * @emits
 * - add: triggered when we need to add a new initiatives
 * - save: triggered when newly created initiative is saved
 * - remove: triggered when we need to remove an initiative. e.g on escape remove initiative that is not yet saved
 * - update: triggered when an initiative is updated
 */
export default {
  name: 'BoardView',
  props: ['goals', 'groups', 'isFetchingGroups', 'viewId', 'groupInfo', 'groupBy'],
  components: {
    InitiativeCard,
    BoardShimmer,
    BButton
  },
  data() {
    return {
      statusKey: INITIATIVE_FIELDS.STATUS.id
    }
  },
  computed: {
    krs() {
      return R.flatten(this.goals?.map(goal => goal.keyResults.filter(x => !x.isArchived)))
    }
  }
}
</script>

<style lang="scss" scoped>
@import '~@/styles/components/_board.scss';

$sideSpacing: 10px;
.group-name {
  margin-bottom: 10px;
  padding: 0 $sideSpacing;
}

.add-initiative {
  margin: 0 $sideSpacing;
}

.cards-container {
  @include scrollbarWidth($scrollSecondary);

  min-height: 60px;
  overflow-y: auto;
  padding: 0 $sideSpacing/2;
  margin: 0 $sideSpacing/2;
}

.board {
  overflow-x: auto;
  margin-bottom: 3px;
}
</style>

<style lang="scss">
.gu-mirror.card {
  box-shadow: 0px 1px 2px rgba(66, 66, 66, 0.25), 0px 15px 20px #c1c1c1;
  transform: rotate(2.79deg);
}
</style>
